import React, { useState, useContext, useEffect } from 'react'
import MetaTags from 'react-meta-tags';
import { CompanyContext } from '../../global_setting/Store';
import Header from './Header'
import Footer from './Footer'
import config from '../../../src/config.json'
import history from '../../history'
import FooterFixed from './FooterFixed'
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import _debounce from 'lodash.debounce'
import OfferSection from './sections/OfferSection'
import AboutSection from './sections/AboutSection'
import ServiceSection from './sections/ServiceSection'
import PackageSection from './sections/PackageSection';
import RoomSection from './sections/RoomSection';
import TestimonialSection from './sections/TestimonialSection';
import FacebookSection from './sections/FacebookSection';
import BlogSection from './sections/BlogSection';
import EventSection from './sections/EventSection';
import NewsletterSection from './sections/NewsletterSection';
import ContactSection from './sections/ContactSection';
import NearbyPlacesSection from './sections/NearbyPlacesSection';
import FacilitiesSection from './sections/FacilitiesSection';
import PromotionalBannerSection from './sections/PromotionalBannerSection';
import PromotionSection from './sections/PromotionSection';
import AwardsSection from './sections/AwardsSection';
import BookingBenefitsSection from './sections/BookingBenefitsSection';
import CustomFooterSection from './sections/CustomFooterSection';
import CustomSection from './sections/CustomSection';

function Gallery() {
    const [companyDetails] = useContext(CompanyContext);
    let company_id_val = companyDetails && companyDetails.company_id;
    const [galleryPageData, setGalleryPageData] = useState();

    useEffect(() => {
        (async function () {
            try {
                if (company_id_val) {
                    let company_id = companyDetails.company_id
                    let template_id = companyDetails.template_id
                    let display_default_footer = true;

                    const pageData = await fetch(
                        config.apiEndpoint + '/wb-frontview/get-frontview-gallery-page-data/' + company_id + '/' + template_id
                    );
                    const result = await pageData.json();

                    if (result && result.gallery_page_data && result.gallery_page_data.page_section) {
                        for (let i = 0; i < result.gallery_page_data.page_section.length; i++) {
                            if (result.gallery_page_data.page_section[i].section_names === "Custom Footer") {
                                display_default_footer = false
                            }
                        }
                    }


                    setGalleryPageData({ "gallery_page_data": result && result.gallery_page_data, "page_section": result && result.gallery_page_data && result.gallery_page_data.page_section, "gallery_data": result && result.gallery_data, "gallery_category": result && result.category_list, "display_default_footer": display_default_footer })

                }
            } catch (e) {
                console.error(e);
            }
        })();
    }, [company_id_val])

    const [scrolled, setscroll] = useState(false)
    if (scrolled === false) {
        window.scrollTo(0, 0)
    }

    window.addEventListener('scroll', function () {
        setscroll(true);
    });

    let video_banner_link = galleryPageData && galleryPageData.gallery_page_data && galleryPageData.gallery_page_data.video_banner_link
    video_banner_link = video_banner_link && video_banner_link.slice(video_banner_link.indexOf("."), video_banner_link.length)
    video_banner_link = video_banner_link && video_banner_link.slice(video_banner_link.indexOf("/") + 1, video_banner_link.length)

    let display_video_banner_link = galleryPageData && galleryPageData.gallery_page_data && galleryPageData.gallery_page_data.video_banner

    return (
        <div>

            {(galleryPageData === undefined) ? <div className="loader"></div> : <Header />}

            {galleryPageData && galleryPageData.gallery_page_data &&
                <MetaTags>
                    <meta charSet="UTF-8" />
                    <title>{galleryPageData.gallery_page_data.seo_title}</title>
                    <meta name="description" content={galleryPageData.gallery_page_data.seo_description} />
                </MetaTags>
            }


            {galleryPageData && galleryPageData.gallery_page_data && galleryPageData.gallery_page_data.banner &&
                <section className="banner_area" style={{ backgroundImage: "url(" + config.wbImagesEndpoint + '/' + galleryPageData.gallery_page_data.banner + ")" }}>
                    <div className="container">
                        <div className="banner_inner_content">
                            <h3 >{galleryPageData.gallery_page_data.banner_title}</h3>
                            <ul>
                                <li className="active"><a onClick={() => history.push(config.PATH + 'home')}>Home</a></li>
                                <li><a style={{ color: 'white' }}>{galleryPageData.gallery_page_data.banner_title}</a></li>
                            </ul>
                        </div>
                    </div>
                </section>}


            {galleryPageData && galleryPageData.gallery_page_data && galleryPageData.gallery_page_data.video_banner && <section>
                <div className="video-date-picker-wrapper">
                    <div className="video-wrapper">
                        <video playsInline="playsinline" autoPlay="autoplay" muted="muted" loop="loop">
                            <source src={config.wbImagesEndpoint + '/' + galleryPageData.gallery_page_data.video_banner} type="video/mp4" />
                            <source src={config.wbImagesEndpoint + '/' + galleryPageData.gallery_page_data.video_banner} type="video/ogg" />
                        </video>
                    </div>
                </div>
            </section>}


            {!display_video_banner_link && video_banner_link && <section>
                <div className="video-date-picker-wrapper">
                    <div className="video-container-youtube">
                        <iframe type="text/html" className="video-youtube" src={"https://www.youtube.com/embed/" + video_banner_link + "?&amp;autoplay=1&amp;loop=1&amp;rel=0&amp;showinfo=0&amp;controls=0&amp;color=white&amp;iv_load_policy=3&amp;"} allow="autoplay" frameBorder="0" allowFullScreen></iframe>
                    </div>
                </div>
            </section>}


            {galleryPageData && galleryPageData.gallery_page_data && galleryPageData.gallery_page_data.page_title && <div className="container">
                <div className="page-header text-center text-uppercase">
                    <h1>{galleryPageData.gallery_page_data.page_title}</h1>
                </div>
                <div className="center_title">
                    <p dangerouslySetInnerHTML={{ __html: galleryPageData.gallery_page_data.page_description }}></p>
                </div>
            </div>}



            {galleryPageData && <GalleryAlt data={galleryPageData} />}

            {galleryPageData && galleryPageData.page_section && galleryPageData.page_section.map(function (item, i) {

                if (item.section_names === "Promotional Banner") {
                    return (
                        <PromotionalBannerSection key={i} />
                    )
                }

                if (item.section_names === "Newsletter") {
                    return (
                        <NewsletterSection key={i} />
                    )
                }

                if (item.section_names === "About Us") {
                    return (
                        <AboutSection key={i} />
                    )
                }

                if (item.section_names === "Rooms") {
                    return (
                        <RoomSection key={i} />
                    )
                }


                if (item.section_names === "Facility") {
                    return (
                        <FacilitiesSection key={i} />
                    )
                }

                if (item.section_names === "Contact Us") {
                    return (
                        <ContactSection key={i} />
                    )
                }

                if (item.section_names === "Services") {
                    return (
                        <ServiceSection key={i} />
                    )
                }


                if (item.section_names === "Nearby Places") {
                    return (
                        <NearbyPlacesSection key={i} />
                    )
                }

                if (item.section_names === "Testimonial") {
                    return (
                        <TestimonialSection key={i} />
                    )
                }


                if (item.section_names === "Event") {
                    return (
                        <EventSection key={i} />
                    )
                }


                if (item.section_names === "Package") {
                    return (
                        <PackageSection key={i} />
                    )
                }


                if (item.section_names === "Blog") {
                    return (
                        <BlogSection key={i} />
                    )
                }

                if (item.section_names === "Offer") {
                    return (
                        <OfferSection key={i} />
                    )
                }


                if (item.section_names === "Facebook") {
                    return (
                        <FacebookSection key={i} />
                    )
                }

                if (item.section_names === "Promotions") {
                    return (
                        <PromotionSection key={i} />

                    )
                }

                if (item.section_names === "Awards") {
                    return (
                        <AwardsSection key={i} />
                    )
                }


                if (item.section_names === "Booking Benfits") {
                    return (
                        <BookingBenefitsSection key={i} />
                    )
                }

                if (item.section_type === "custom") {
                    return (
                        <CustomSection key={i} section_id={item.id} name={item.section_names}/>
                    )
                }
                
                if (item.section_names === "Custom Footer") {
                    return (
                        <CustomFooterSection key={i} />
                    )
                }
            })}

            {galleryPageData && galleryPageData.display_default_footer && galleryPageData.display_default_footer === true && <Footer />}

            {galleryPageData && <FooterFixed />}
        </div>

    );
}


function GalleryAlt(props) {
    let gallery_details = props.data
    const [screen_size, setScreensize] = useState(window.innerWidth)
    const [category, setCategory] = useState('All Image')
    const images = [];

    const [open, isopen] = useState(false)
    const [index, setindex] = useState()
    const Toggle = (name, idx) => {
        isopen(true);
        setindex(idx);
    }
    useEffect(() => {
        const handleResize = _debounce(() => setScreensize(window.innerWidth), 100)
        window.addEventListener('resize', handleResize);
    });

    var allImg = []
    allImg = gallery_details && gallery_details.gallery_data && gallery_details.gallery_data[gallery_details.gallery_data.length - 1]

    return (
        <div>
            {gallery_details && gallery_details.gallery_data.length !== 0 ?
                <div>
                    <section className="grid_gallery_area" style={{ position: "relative", zIndex: 0 }} >
                        <div className="container">
                            {(gallery_details === undefined) ? '' : (screen_size > 767) ?
                                <ul className="gallery-filter text-center">
                                    <li className={(category === "All Image") ? "gallery-sorter active" : "gallery-sorter"} onClick={() => setCategory("All Image")}><span>All images</span></li>
                                    {gallery_details && gallery_details.gallery_category.map(function (item, i) {
                                        return (
                                            <li className={(category === item.category_name) ? "gallery-sorter active" : "gallery-sorter"} key={i} onClick={() => setCategory(item.category_name)}><span>{item.category_name}</span></li>
                                        )
                                    })}
                                </ul>
                                :
                                <div className="galleryButton">
                                    <div className={(category === "All Image") ? "cardgallery active" : "cardgallery"} onClick={() => setCategory("All Image")}>
                                        <h6>All images</h6>
                                    </div>
                                    {gallery_details && gallery_details.gallery_category.map(function (item, i) {
                                        return (
                                            <div className={(category === item.category_name) ? "cardgallery active" : "cardgallery"} key={i} onClick={() => setCategory(item.category_name)}>
                                                <h6>{item.category_name}</h6>
                                            </div>
                                        )
                                    })}
                                </div>
                            }
                            <div className="grid_gallery_inner">
                                {category === "All Image" ? <div className="row grid_gallery_item_inner imageGallery1">
                                    <div className="gallery-image-display">
                                        <ul>
                                            {allImg && allImg.map(function (items, id) {
                                                images.push(config.wbImagesEndpoint + "/" + items)
                                                return (
                                                    <li key={id}><img src={config.wbImagesEndpoint + '/' + items} alt="" onClick={() => Toggle(items, id)} /></li>
                                                )
                                            })}
                                            <li></li>
                                        </ul>
                                    </div>
                                </div> :
                                    <div className="row grid_gallery_item_inner imageGallery1">
                                        {gallery_details && gallery_details.gallery_data && gallery_details.gallery_data.length > 0 && gallery_details.gallery_data.map(function (item, i) {
                                            if (category === item.category) {
                                                return (
                                                    <div className="gallery-image-display" key={i}>
                                                        <ul>
                                                            {item.image_name.map(function (items, id) {
                                                                images.push(config.wbImagesEndpoint + "/" + items)
                                                                return (
                                                                    <li key={id}><img src={config.wbImagesEndpoint + '/' + items} alt={item.image_name_alt} onClick={() => Toggle(items, id)} /></li>
                                                                )
                                                            })}
                                                            <li></li>
                                                        </ul>
                                                    </div>
                                                )
                                            }

                                        })}
                                    </div>
                                }
                            </div>
                        </div>
                    </section>
                </div>

                : ''}
            {open && (
                <Lightbox
                    className="test"
                    mainSrc={images[index]}
                    thumbnailWidth='150px'
                    thumbnailHeight='150px'
                    nextSrc={images[(index + 1) % images.length]}
                    prevSrc={images[(index + images.length - 1) % images.length]}
                    onCloseRequest={() => isopen(false)}
                    onMovePrevRequest={() =>
                        setindex((index + images.length - 1) % images.length)
                    }
                    onMoveNextRequest={() =>
                        setindex((index + 1) % images.length)
                    } />
            )}
        </div>
    )

}

export default Gallery;
